/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  Vue, Component, Prop, Model,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Button, Popup } from 'vant';
import { SupportBankCard } from '@/api/bank-card/types';

import style from './index.module.scss';

const CardBindState = namespace('cardBind');
const defaultLogo = require('./images/card@3x.png') as string;

@Component
export default class SupportList extends Vue {
  @Model('change', {
    type: Boolean,
  })
  readonly visible!: boolean;

  @Prop(String) readonly commodityId!: string;

  @Prop(String) readonly capitalCode!: string;

  @CardBindState.State supportList!: SupportBankCard[];

  private onConfirm() {
    this.$emit('closeSupportList');
  }

  private onCancel() {
    this.$emit('closeSupportList');
  }

  private render() {
    /* 可支持银行卡列表 */
    return (
      <Popup
        v-model={this.visible}
        safeAreaInsetBottom={true}
        closeOnClickOverlay={false}
        class={style.popupStyle}
        onClick-overlay={this.onCancel.bind(this)}
      >
        <div class={style.supportList}>
          <p class={style.title}>当前渠道支持银行</p>
          <div class={style.tip}>部分银行单日限额5万，以实际操作为准</div>
          <div class={style.cardList}>
            {this.supportList.map((item) => {
              const { logo } = item.extendInfo || {};
              return (
                <div key={item.code} class={style.listItem}>
                  <span
                    class={style.bankLogo}
                    style={{
                      backgroundImage: `url(${logo || defaultLogo})`,
                    }}
                  />
                  {item.name}
                </div>
              );
            })}
          </div>
        </div>
        <Button
          type="primary"
          class={style.confirmButton}
          onClick={() => this.onConfirm()}
        >
          知道了
        </Button>
      </Popup>
    );
  }
}
